import { render } from "./NameList.vue?vue&type=template&id=41e78298"
import script from "./NameList.vue?vue&type=script&lang=js"
export * from "./NameList.vue?vue&type=script&lang=js"

import "./NameList.vue?vue&type=style&index=0&id=41e78298&lang=less"

import exportComponent from "F:\\workspace\\clientapps\\Advertising-Platform\\node_modules\\_vue-loader@16.8.3@vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__